import React, { FunctionComponent } from 'react'

import { faPlus } from '@fortawesome/pro-light-svg-icons'

import Button from '../../../../../../../../App/Components/Button/Button'

import { IProps } from './IProps'
import { AddIcon } from './style'
import {useTranslation} from 'react-i18next'

export const IdleSelectState: FunctionComponent<IProps> = ({
    setActivitySelectObject,
}) => {
    const { t } = useTranslation()

    return (
        <>
            <Button
                type={'button'}
                onClick={() =>
                    setActivitySelectObject({
                        type: 'menu',
                        activeSelection: [],
                        selectionDetails: null,
                    })
                }
            >
                <AddIcon icon={faPlus} />
                {t('Menu')}
            </Button>
            <Button
                type={'button'}
                onClick={() =>
                    setActivitySelectObject({
                        type: 'activity',
                        activeSelection: [],
                        selectionDetails: null,
                    })
                }
            >
                <AddIcon icon={faPlus} />
                {t('Activity')}
            </Button>
        </>
    )
}
